<template>
  <div>
    <v-navigation-drawer v-model="appsBar.status"
                         clipped
                         :floating="appsBar.floating"
                         :mini-variant="appsBar.mini"
                         app dark>
      <v-list dense rounded>
        <v-list-item-group nav active-class="grey--text">
          <router-link v-for="item in appsBar.items" :key="item.title" :to="item.to" tag="v-list-item">
            <v-list-item link @click="appsBar.title = item.title" style="margin:5px">
              <v-list-item-icon>
                <v-icon>{{item.icon}}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{item.title}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-item-group>
      </v-list>
      <!--</v-img>-->
    </v-navigation-drawer>

    <v-app-bar :clipped-left="appsBar.clipped" app>
      <v-app-bar-nav-icon @click.stop="appsBar.status = !appsBar.status"></v-app-bar-nav-icon>
      <v-toolbar-title class="headline">
        <span class="font-weight-light header">{{appsBar.title}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-progress-circular v-if="appsBar.loading_status" :width="3" color="primary" indeterminate style="margin: 5px"></v-progress-circular>
      <v-btn fab small elevation="0" color="white" @click="signOut()">
        <v-icon color="#3949AB">fas fa-sign-out-alt</v-icon>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: 'appsBar',
  data: () => ({
    appsBar: {}
  }),
  created () {
    this.appsBar = this.$store.state.appsBar
  },
  methods: {
    signOut () {
      this.$cookies.remove('username')
      this.$cookies.remove('password')
      this.$store.state.apps.login_status = false
    }
  }
}
</script>

<style scoped>

</style>
